import React, { useState } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Loader from "../../component/loaderComponent/Loader";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import NodataFound from "../../component/NodataFound";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

const ProductTrainings = ({
  tutorialListData,
  filterSearch,
  startIndex,
  tutorialData,
  page,
  searchvalue,
  selectedCheckbox,
  handleEditClick,
  handleFilterTypeCheckboxChange,
  handleChange,
  isLoading,
  OpenThumbnailPopup
}) => {
  const { i18n, t } = useTranslation();

  return (
    <div>
      <div>
        <div className="productTrainingPanel_checkbox">
          <div className="checkbox_contain">
            <div className="checkbox_container">
              <input
                className="input_checkbox"
                type="checkbox"
                name="checkbox"
                value=""
                checked={selectedCheckbox === ""}
                onChange={handleFilterTypeCheckboxChange}
              />
              <span className={selectedCheckbox === "" ? "checkbox_labelactive" : "checkbox_label"}>
              {t('tutorialtraining.all')}
              </span>
            </div>
            <div className="checkbox_containerTutorial">
              <input
                className="input_checkbox"
                type="checkbox"
                name="tutorial"
                value="tutorial"
                checked={selectedCheckbox === "tutorial"}
                onChange={handleFilterTypeCheckboxChange}
              />
              <span className={selectedCheckbox === "tutorial" ? "checkbox_labelactive" : "checkbox_label"}>
              {t('tutorialtraining.tutorial')}
              </span>
            </div>
            <div className="checkbox_containerTrouble">
              <input
                className="input_checkbox"
                type="checkbox"
                name="trouble_shooting"
                value="trouble_shooting"
                checked={selectedCheckbox === "trouble_shooting"}
                onChange={handleFilterTypeCheckboxChange}
              />
              <span className={selectedCheckbox === "trouble_shooting" ? "checkbox_labelactive" : "checkbox_label"}>
              {t('tutorialtraining.troubleshooting')}
              </span>
            </div>
          </div>
          <div className="productTrainingdropdown_div">
            <div className="input-wrapper">
              <label htmlFor="search">{t('partlist.search')}</label>
              <input
                type="text"
                className="input_search"
                placeholder={t('partlist.search')}
                value={searchvalue}
                onChange={handleChange}
              />
            </div>
          </div>
          <button
            className="button_search"
            onClick={() => filterSearch(selectedCheckbox, searchvalue)}
            disabled={!searchvalue}
          >
            {t('partlist.search')}
          </button>
        </div>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="tabledata-product">
          {tutorialListData?.length > 0 ?
            <table className="table">
              <tr>
                <th className="tablesth"> {t('pgmlist.sNo')}</th>
                <th className="tablesth">{t('tutorialtraining.thumbnail')}</th>
                <th className="tablesth">{t('tutorialtraining.title')}</th>
                <th className="tablesth">{t('tutorialtraining.description')}</th>
                <th className="tablesth">{t('tutorialtraining.vehicle')}</th>
                <th className="tablesth flex_updown">{t('tutorialtraining.type')}</th>
                <th className="tablesth"></th>
                <th className="tablesth"></th>
              </tr>
              {tutorialListData.map((data, i) => (
                <tr key={i}>
                  <td className="tabletd">{i + startIndex}</td>
                  <td className="tabletd" 
                  data-attachment_type ={data?.attachment_type} >
                    <img
                    onClick={()=>OpenThumbnailPopup(data.attachment,data?.attachment_type.toLowerCase())}
                      height="77.78pxpx"
                      width="126px"
                      className=""
                      src={data?.attachment_type.toLowerCase() === "pdf" ? Image_Url.PDF_THUMBNAIL : data?.attachment_type.toLowerCase() === "video" || data?.attachment_type.toLowerCase() === "scorm"
                      ? (data.video_thumbnail === null ? Image_Url.VIDEO_THUMBNAIL : data.video_thumbnail) : Image_Url.PDF_THUMBNAIL
                      }
                    />
                  </td>
                  <td className="tabletd">{data.title} </td>
                  <td className="tabletd"><Tooltip arrow title={String(data?.description).length>100?String(data.description):""}><div style={{padding:0,marginBottom:"-20px"}}>{String(data.description).substring(0,100) + (String(data?.description).length>100?"...":"")}</div></Tooltip> </td>
                  {data.vehicle_list.length > 0 ? (
                    <td className="tabletd">{data.vehicle_list[0].name}</td>
                  ) : (
                    <td className="tabletd">Undefined</td>
                  )}
                  <td className="tabletd">{data.attachment_type ? data.attachment_type : undefined}</td>
                  {hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_TUTORIAL_DETAILS) && (
                    <td
                    className="tabletd_view"
                    onClick={() =>  handleEditClick(data.id)}
                    >
                      {t('partlist.edit')}
                    </td>
                  )}
                </tr>
              ))}
            </table>
            :
            <NodataFound/>
          }
        </div>
      )}
    </div>
  );
};

export default ProductTrainings;
